/**
 * status 当前订单的状态的下一个状态，在父组件，可通过 import orderflowHelper from '@/config/order'，然后orderflowHelper.getNextOrderStatus('flow1', '当前订单状态', true)得到下一个订单状态
 */
<template>
<!-- 正常状态的显示；代办状态的显示 -->
	<div class="order-status-form clearfix">
    <template v-if="orderStatustType==='normal'">
      <!-- <div class="title" v-text="title"></div> -->
      <component v-if="status!=='CLOSED'" v-show="!hideForm" :is="compName" ref="orderStatusForm" v-bind="$attrs" :status="status" :order="order" :detailIn="true" :orderStatus="orderStatus" @updateLoading="updateLoading" @on-error="onError" @on-success="onSuccess" @doNext="doNext"></component>
      <el-button v-if="!hideForm&&order.orderStatusEnum!='CLOSED'&&order.orderStatusEnum!='COMPLETED'" size="small" @click="next" type="primary" class="next btn" :class="statusColor">下一步</el-button>
      <slot></slot>
    </template>
    <template v-else-if="orderStatustType==='pending'">
      <div :class="$style['table']" v-if="detectionResultData">
        <div :class="$style.table__title">致病基因变异检出（需验证）</div>
        <pt-gene-detection-result :data="detectionResultData"></pt-gene-detection-result>
      </div>
      <task-operate :task="task"
      @on-success="onSuccess"
      @before-submit="updateLoading"
      @on-error="onError" :orderDetail="orderDetail"></task-operate>
    </template>
	</div>
</template>
<script>
import orderflowHelper from '@/config/order'
import LAB_SAMPLES_RECEIVED from './form/LAB_SAMPLES_RECEIVED'
import LAB_DNA_READY from './form/LAB_DNA_READY'
import REPORT_CHECKED_1ST from './form/REPORT_CHECKED_1ST'
import DATA_ANALYSISED from './form/DATA_ANALYSISED'
import REPORT_CREATED from './form/REPORT_CREATED'// 报告生成
// 成人实验室订单
import ADULT_LAB_SAMPLES_RECEIVED from './form/ADULT_LAB_SAMPLES_RECEIVED'
import PREPARED from './form/PREPARED'
import WAREHOUSING from './form/WAREHOUSING'
import ADULT_REPORT_CHECKED_1ST from './form/ADULT_REPORT_CHECKED_1ST'
import ADULT_COMPLETED from './form/ADULT_COMPLETED'
import taskOperate from './form/components/task-operate'
// 突变报告结果表
import ptGeneDetectionResult from 'cps/lab-order/pt-gene-detection-result'
export default {
  name: 'order-status',
  props: {
    task: {
      type: Object
    },
    status: {
      type: String,
      required: true
    },
    hideForm: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      required: true
    },
    orderStatus: [Array],
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    DATA_ANALYSISED,
    LAB_SAMPLES_RECEIVED,
    LAB_DNA_READY,
    REPORT_CHECKED_1ST,
    REPORT_CREATED,
    taskOperate,
    ptGeneDetectionResult,
    ADULT_LAB_SAMPLES_RECEIVED,
    PREPARED,
    WAREHOUSING,
    ADULT_REPORT_CHECKED_1ST,
    ADULT_COMPLETED

    // orderHandleDialog
    // MUTATION_VERIFICATION,
    // SAMPLE_RECOLLECT
  },
  data () {
    return {
      title: '',
      creatNum: 0
    }
  },
  computed: {
    compName () {
      let isAdult = Boolean(this.$route.name === 'adult-sell-order-detail')
      if (!isAdult) {
        return this.status
      } else {
        if (this.status === 'NONE') {
          return 'ADULT_COMPLETED'
        }
      }
      return orderflowHelper.getStatusTag(this.status, isAdult)
    },
    orderStatustType () {
      let type = 'normal'
      if (this.task) {
        type = 'pending'
      }
      return type
    },
    // 突变报告结果数据
    detectionResultData () {
      let res = null
      if (this.task) {
        let mutationVerifyInformation = this.task.orderActionData.statusDetail ? this.task.orderActionData.statusDetail.mutationVerifyInformation : null
        if (mutationVerifyInformation) {
          res = []
          mutationVerifyInformation.forEach(item => {
            let { geneType, autoCausalAnalysisResults } = item
            autoCausalAnalysisResults.forEach(item => {
              let { autoCausalLociParam } = item
              res.push({
                geneType,
                ...autoCausalLociParam
              })
            })
          })
        }
      }
      return res
    },
    statusColor () {
      if (this.creatNum === 1) {
        return 'orange'
      } else if (this.creatNum > 1) {
        return 'red'
      }
      return ''
    }
  },
  mounted () {
    this.$refs.orderStatusForm && (this.title = this.$refs.orderStatusForm.title)
  },
  methods: {
    btnColor () {
      for (let status of this.orderStatus) {
        if (status.orderStatus === 'LAB_SAMPLE_RETURNED') {
          this.creatNum = this.creatNum + 1
        }
      }
    },
    next () {
      let formValidata = this.$refs.orderStatusForm.formValidata
      if (formValidata) {
        formValidata().then(response => {
          this.doNext()
        }).catch(err => {
          console.warn(err)
        })
      } else {
        this.doNext()
      }
    },
    doNext () {
      this.$emit('isLoading', true)
      this.$refs.orderStatusForm.next().then(response => {
        this.$emit('isLoading', false)
        this.$emit('status-change')
      }).catch(err => {
        this.$emit('isLoading', false)
        this.$message.error(err)
        console.warn(err)
      })
    },
    updateLoading (val) {
      this.$emit('isLoading', true)
    },
    onSuccess (data) {
      if (data) {
        let { isDELETE } = data
        if (isDELETE) {
          history.go(-1)
          return
        }
      }
      this.$emit('status-change')
    },
    onError () {
      this.$emit('isLoading', false)
    }
  },
  watch: {
    orderStatus (val) {
      this.creatNum = 0
      this.btnColor()
    }
  },
  created () {
    this.btnColor()
  }
}
</script>
<style lang="less">
.order-status-form{
  padding: 40px 20px;
  .el-button.next{
    margin-top:30PX;
  }
  el-textarea,.el-textarea__inner,.el-input__inner{
    width:500px;
  }
  .el-upload-list{
    max-width: 800px;
  }
}
</style>
<style module lang="less">
.table{
  margin-bottom:20px;
  &__title{
    font-weight: bold;
    padding:20px 0;
  }
}
.upload{
  margin-top:20px;
}
</style>
